import type { BuildingType } from "components/BuildingProfile/types";

import type { MixUseKey } from "./types";

// TODO: Link these to the ESG
export const MIX_USE_KEYS: MixUseKey[] = [
  "office",
  "residential",
  "retail",
  "industrial",
  "hospitality",
  "healthcare",
  "education",
  "hotel",
  "logistics",
  "other",
];

export const SUMMARY_BUILDING_TYPE_OPTIONS = [...MIX_USE_KEYS, "mixed"];

export const DEFAULT_MIX_CONFIGURATION = Object.fromEntries(MIX_USE_KEYS.map((key) => [key, 0])) as Record<
  MixUseKey,
  number
>;

export const isMixedBuilding = (buildingType: BuildingType | undefined) => {
  return buildingType === "mixed";
};
